<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 発送予定詳細画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="発送予定基本情報" name="prepTransBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <!-- 輸送方式 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.TRANSPORT_METHOD')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 輸送方式（空白のオプション）の追加-->
                    <!-- <t-input
                      v-model="prepTransEditForm.ptbTransMethodShow"
                      class="commonDialog"
                      maxLength="20"
                      disabled
                    >
                    </t-input> -->
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="prepTransEditForm.ptbTransMethod"
                      :disabled="transOverKbn"
                    > -->
                    <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="prepTransEditForm.ptbTransMethod"
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in transMethodList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                  </t-form-item>
                </t-col>
                <!-- 出発日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.DEPARTURE_DATE')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-date-picker
                      v-model="prepTransEditForm.ptbDepartureDateShow"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      :clearable="false"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="transOverKbn"
                    > -->

                    <t-date-picker
                      v-model="prepTransEditForm.ptbDepartureDateShow"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      :clearable="false"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <!-- 到着予定日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.EXPECT_DATE_ARRIVE')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-date-picker
                      v-model="prepTransEditForm.ptbEstArrivalDateShow"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="transOverKbn"
                    > -->
                    <t-date-picker
                      v-model="prepTransEditForm.ptbEstArrivalDateShow"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-date-picker>
                  </t-form-item>
                </t-col>
                <!-- 運送No -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.TRANSPORT_NO')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input
                      v-model="prepTransEditForm.ptbTransOrderNo"
                      class="commonDialog"
                      maxLength="20"
                      :disabled="transOverKbn"
                    > -->
                    <t-input
                      v-model="prepTransEditForm.ptbTransOrderNo"
                      class="commonDialog"
                      maxLength="20"
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 目的地 -->
                <t-col :span="colArr.colCom * 2">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.DESTINATION')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input
                      v-model="prepTransEditForm.ptbDestination"
                      class="commonDialog"
                      maxLength="50"
                      :disabled="transOverKbn"
                    > -->
                    <t-input
                      v-model="prepTransEditForm.ptbDestination"
                      class="commonDialog"
                      maxLength="50"
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.STATUS')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="prepTransEditForm.ptbTransStatusShow"
                      class="commonDialog"
                      maxLength="20"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 連絡担当 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.CONNECTER')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-select
                      v-model="prepTransEditForm.ptbUserCode"
                      placeholder=""
                      class="commonDialog"
                      :disabled="transOverKbn"
                    > -->
                    <t-select
                      v-model="prepTransEditForm.ptbUserCode"
                      placeholder=""
                      class="commonDialog"
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR" />
              </t-row>

              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 備考 -->
                <t-col :span="colArr.colCom * 4">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.REMARKS')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input
                      v-model="prepTransEditForm.ptbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                      :disabled="transOverKbn"
                    > -->
                    <t-input
                      v-model="prepTransEditForm.ptbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                      :disabled="transOverKbn || !isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR"></t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>

          <t-row>
            <t-col
              :span="
                parseInt($t('widgetSize.TRANSPORT_EDIT_DIALOG.SPAN_BTN_THREE'))
              "
              class="col_common_left"
            >
              <!-- 未運送製品選択 -->
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
              <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="selectBtn"
                @click="ProdSelectDialog"
                :disabled="prodSelectFlg || transOverKbn"
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="selectBtn"
                @click="ProdSelectDialog"
                :disabled="prodSelectFlg || transOverKbn || !isDLUserLocal"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                <i class="el-icon-s-order"></i>
                {{ $t("resource.PREPARE_TRANS.PROD_SELECT_DIALOG") }}
              </t-button></t-col
            >

            <t-col
              :span="
                parseInt($t('widgetSize.TRANSPORT_EDIT_DIALOG.SPAN_BTN_THREE'))
              "
              class="col_common_left"
            >
              <!-- 削除 -->
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
              <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
              <!-- <t-button
                round
                type="danger"
                class="dialogButton_180_40"
                ref="delBtn"
                @click="deleteClickSelected"
                :disabled="transOverKbn || confirmBtnFlg"
              > -->
              <t-button
                round
                type="danger"
                class="dialogButton_180_40"
                ref="delBtn"
                @click="deleteClickSelected"
                :disabled="transOverKbn || confirmBtnFlg || !isDLUserLocal"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                <i class="el-icon-delete"></i>
                {{ $t("resource.sys.delete") }}
              </t-button>
            </t-col>
            <t-col :span="3" class="col_common_left">
              <template>
                <!-- 全て製品表示のチェックボックス： -->
                <t-checkbox
                  v-model="allProdShowFlg"
                  @change="handleCheckboxChange"
                  :label="$t('resource.PREPARE_TRANS.PROD_ALL_SHOW')"
                  style="line-height: 3; margin-top: 3px; margin-left: 5px"
                />
              </template>
            </t-col>

            <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
            <t-col :span="3" class="col_common_left">
              <template>
                <!-- 未入荷のチェックボックス -->
                <t-checkbox
                  v-model="disRcvFlg"
                  @change="handleCheckboxChange"
                  :label="$t('resource.PREPARE_TRANS.REC_REMAIN_FLG')"
                  style="line-height: 3; margin-top: 3px; margin-left: 5px"
                />
              </template>
            </t-col>
            <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

            <!-- 検索キー -->
            <t-col :span="5" class="col_common_left">
              <t-input
                ref="searchInput"
                v-model="searchWord"
                placeholder="キーワードを入力して検索する"
                @blur="handleCheckboxChange"
                maxLength="50"
                @clear="handleClear"
                @keyup.native.enter="handleCheckboxChange"
                class="input_icon_close"
                style="margin-top: 10px"
                clearable
              >
                <t-button
                  slot="append"
                  icon="el-icon-search"
                  class="button-default custom-button"
                  @click="handleCheckboxChange"
                ></t-button>
              </t-input>
            </t-col>
            <t-col :span="5" class="right">
              <!-- 出力 -->
              <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                @click="OutPutClick"
                ref="outputBtn"
                :disabled="btnOutputFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.PREPARE_TRANS.PROC_LIST_OUTPUT") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="prepTransDetailTable"
                :data="filteredDetailTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                :height="detailHeight"
                :row-class-name="rowClassName"
                border
                fit
              >
                <!-- UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓ -->
                <!-- <t-table-column type="selection" class-name="cell_txt_center" /> -->
                <t-table-column
                  type="selection"
                  class-name="cell_txt_center"
                  :selectable="checkSelectable"
                />
                <!-- UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->
                <t-table-column
                  width="70"
                  class-name="cell_txt_left input_font_small"
                  prop="ptdTransDetailNo"
                  :label="$t('resource.PREPARE_TRANS.TRANS_DETAIL_NO')"
                  :fixed="true"
                >
                </t-table-column>
                <!-- ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <template
                    v-if="column.children && column.children.length > 0"
                  >
                    <t-table-column
                      v-for="(columnSon, indexSon) in column.children"
                      :key="indexSon"
                      :type="columnSon.type"
                      :prop="columnSon.prop"
                      :label="columnSon.label"
                      :min-width="
                        columnSon.prop !== 'aodProdRemarksSum'
                          ? columnSon.width
                          : undefined
                      "
                      :align="columnSon.align"
                      :header-align="columnSon.headerAlign"
                      :class-name="`${columnSon.class} input_font_small`"
                      :show-overflow-tooltip="columnSon.overflowTooltip"
                      :width="
                        columnSon.prop === 'aodProdRemarksSum'
                          ? getRemarksColumnWidthProc()
                          : undefined
                      "
                    >
                      <template #default="scopeChildren">
                        <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                        <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                        <!-- <t-input-number
                          v-if="
                            columnSon.prop === 'ptdTransQty' && !transOverKbn
                          "
                          class="cell_input_number cell_input_font_small"
                          :controls="false"
                          :precision="0"
                          :min="0"
                          :max="99999"
                          width="100%"
                          v-model="scopeChildren.row[columnSon.prop]"
                          @blur="
                            changeCellData(scopeChildren.row, columnSon.prop)
                          "
                          :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                          @keyup.native.enter="
                            focusNextInput(
                              scopeChildren.row.index,
                              columnSon.prop
                            )
                          "
                          @focus="selectValue($event)"
                        /> -->
                        <t-input-number
                          v-if="
                            columnSon.prop === 'ptdTransQty' &&
                            !transOverKbn &&
                            isDLUserLocal
                          "
                          class="cell_input_number cell_input_font_small"
                          :controls="false"
                          :precision="0"
                          :min="0"
                          :max="99999"
                          width="100%"
                          v-model="scopeChildren.row[columnSon.prop]"
                          @blur="
                            changeCellData(scopeChildren.row, columnSon.prop)
                          "
                          :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                          @keyup.native.enter="
                            focusNextInput(
                              scopeChildren.row.index,
                              columnSon.prop
                            )
                          "
                          @focus="selectValue($event)"
                        />
                        <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                        <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                        <!-- <t-input
                          v-else-if="
                            columnSon.prop === 'ptdQc' && !transOverKbn
                          "
                          maxLength="2"
                          v-model="scopeChildren.row[columnSon.prop]"
                          :disabled="transOverKbn"
                          :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                          @keyup.native.enter="
                            focusNextInput(
                              scopeChildren.row.index,
                              columnSon.prop
                            )
                          "
                          class="cell_input_center cell_input_font_small"
                          @focus="selectValue($event)"
                        /> -->

                        <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                        <!-- 運送区分の削除 -->
                        <!--select-->
                        <!-- <t-select
                          placeholder=""
                          class="commonDialog cell_input_font_small"
                          v-else-if="columnSon.prop == 'ptdTransKbn'"
                          v-model="scopeChildren.row[columnSon.prop]"
                          :disabled="transOverKbn"
                          @change="
                            changeCellData(scopeChildren.row, columnSon.prop)
                          "
                        >
                          <t-option
                            v-for="item in prodTransKbnList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </t-option>
                        </t-select> -->

                        <!-- <t-checkbox
                          v-model="scopeChildren.row['ptdCheckFlgBool']"
                          v-else-if="columnSon.prop == 'ptdCheckFlg'"
                          :disabled="
                            transOverKbn ||
                            scopeChildren.row.ptdTransQty === 0 ||
                            scopeChildren.row.ptdTransKbn !== '0'
                          "
                          @change="handleCheckboxClick(scopeChildren.row)"
                        /> -->

                        <t-input
                          v-else-if="
                            columnSon.prop === 'ptdQc' &&
                            !transOverKbn &&
                            isDLUserLocal
                          "
                          maxLength="2"
                          v-model="scopeChildren.row[columnSon.prop]"
                          :disabled="transOverKbn"
                          :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                          @keyup.native.enter="
                            focusNextInput(
                              scopeChildren.row.index,
                              columnSon.prop
                            )
                          "
                          @change="
                            changeCellData(scopeChildren.row, columnSon.prop)
                          "
                          class="cell_input_center cell_input_font_small"
                          @focus="selectValue($event)"
                        />

                        <t-checkbox
                          v-model="scopeChildren.row['ptdCheckFlgBool']"
                          v-else-if="columnSon.prop == 'ptdCheckFlg'"
                          disabled
                          @change="handleCheckboxClick(scopeChildren.row)"
                        />
                        <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                        <template
                          v-else-if="columnSon.prop === 'aodProdRemarksSum'"
                        >
                          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                          <!-- 共通備考の調整 -->
                          <!-- <div class="button-container">
                             <t-tooltip placement="bottom" effect="light">
                              <div
                                slot="content"
                                class="tooltip-content"
                                v-html="
                                  formatRemarksShowProc(
                                    scopeChildren.row.aodProdRemarksSum
                                  )
                                "
                              ></div>
                              <t-button
                                :type="
                                  getIconTypeProc(
                                    scopeChildren.row.aodProdRemarksSum
                                  )
                                "
                                icon="el-icon-search"
                                size="small"
                                circle
                              >
                              </t-button>
                            </t-tooltip>
                            <t-button
                              v-if="!transOverKbn"
                              type="warning"
                              icon="el-icon-edit"
                              size="small"
                              circle
                              @click="addRemarksProd(scopeChildren.row, $event)"
                            ></t-button>
                          </div> -->
                          <div class="bikouDiv">
                            <!-- 備考表示 -->
                            <span class="bikouText">
                              {{ scopeChildren.row.aodProdRemarksSum }}
                            </span>
                            <!-- 備考編集 -->
                            <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                            <!-- <t-button
                              v-if="!transOverKbn"
                              type="warning"
                              icon="el-icon-edit"
                              size="small"
                              class="bikouButton"
                              circle
                              @click="
                                showRemarksDialogProc(scopeChildren.row, $event)
                              "
                            > -->
                            <t-button
                              v-if="!transOverKbn && isDLUserLocal"
                              type="warning"
                              icon="el-icon-edit"
                              size="small"
                              class="bikouButton"
                              circle
                              @click="
                                showRemarksDialogProc(scopeChildren.row, $event)
                              "
                            >
                              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                            </t-button>
                          </div>
                          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                        </template>

                        <span v-else>
                          {{ scopeChildren.row[columnSon.prop] }}
                        </span>
                      </template>
                    </t-table-column>
                  </template>
                </t-table-column>
                <!-- ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 入荷機能の追加 -->
                <t-table-column
                  :label="$t('resource.DUE_DATE_EDIT.TREATMENT')"
                  :class-name="'cell_txt_center input_font_small'"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!--入荷-->
                    <t-button
                      type="primary"
                      size="small"
                      style="
                        flex-shrink: 0;
                        width: 100px;
                        display: inline-block;
                      "
                      :disabled="!isDLUserLocal || !scope.row.receiveFlag"
                      @click="addCheckReceDataProc(scope.row, $event)"
                    >
                      {{ $t("resource.PREPARE_TRANS.RECEIVE") }}</t-button
                    >
                  </template>
                </t-table-column>
                <!-- ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form>
          <t-row class="right">
            <div>
              <t-col :span="18"> &nbsp; </t-col>
              <!-- 重量合計 -->
              <t-col :span="6">
                <t-input
                  v-model="weightTotal"
                  style="margin-top: 5px; margin-bottom: 5px"
                  :disabled="true"
                  class="sumInput"
                >
                  <template slot="prepend">
                    <span class="span_style">{{
                      $t("resource.PREPARE_TRANS.PROD_WEIGHT_TOTAL_SUM")
                    }}</span></template
                  >
                </t-input>
              </t-col>
            </div>
          </t-row>
          <t-row>
            <div>
              <t-col :span="16" class="right">
                <!-- 一時保存 -->
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <!-- <t-button
                  round
                  type="warning"
                  class="dialogButton_160_40"
                  @click="tempSave"
                  ref="tmpSaveBtn"
                  :disabled="confirmBtnFlg || transOverKbn"
                > -->
                <t-button
                  round
                  type="warning"
                  class="dialogButton_160_40"
                  @click="tempSave"
                  ref="tmpSaveBtn"
                  :disabled="confirmBtnFlg || transOverKbn || !isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                  <i class="el-icon-check"></i>
                  {{ $t("resource.PREPARE_TRANS.TEMP_SAVE_BUTTON") }}</t-button
                >
              </t-col>

              <t-col :span="4" class="right">
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <!-- <t-button
                  round
                  type="warning"
                  class="dialogButton_160_40"
                  @click="transDetailNoCreate"
                  ref="transDetailNoBtn"
                  :disabled="confirmBtnFlg || transOverKbn"
                > -->
                <t-button
                  round
                  type="warning"
                  class="dialogButton_160_40"
                  @click="transDetailNoCreate"
                  ref="transDetailNoBtn"
                  :disabled="confirmBtnFlg || transOverKbn || !isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                  <i class="el-icon-check"></i>
                  {{
                    $t("resource.PREPARE_TRANS.CREATE_TRANS_NO_BUTTON")
                  }}</t-button
                >
              </t-col>
              <t-col :span="4" class="right">
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <t-button
                  round
                  type="warning"
                  class="dialogButton_160_40"
                  @click="transInfoCreate"
                  ref="transCreateBtn"
                  :disabled="transDataBtnFlg || transOverKbn || !isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                  <i class="el-icon-check"></i>
                  {{
                    $t("resource.PREPARE_TRANS.CREATE_TRANS_DATA_BUTTON")
                  }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { ShowPrepTransProdSelectDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { creatReceInfo } from "@/services/checkReceInfo";
import {
  outputExcelToZip,
  showRemarksDialog,
  showRemarksUpdDialog,
} from "@/services/common";
import {
  addPrepTransDetail,
  delPrepTransByDetailNo,
  getInitList,
  getProdSelectData,
  searchPrepTransDetailByNo,
  transInfoCreate,
  updPrepTransDetail,
} from "@/services/prepareTrans";
import {
  cmpBasicData,
  cmpDetailDataExceptRemarks,
  formatCurDateToString,
  formatCurDateToYYYYMMddHHmm,
  formatDateToString,
  formatRemarksShow,
  getAbleUserInfoList,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  FINAL_STR,
  NORMAL_PROD,
  NUM_ONE,
  NUM_ZERO,
  STR_EMPTY,
  STR_ONE,
  STR_ZERO,
} from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["prepTransBasic"],

      // ========================使用フラグ=================
      //未運送製品選択ボタンが使用可
      prodSelectFlg: false,
      // 運送製品リスト出力ボタンが使用可
      btnOutputFlg: false,
      //確定ボタンの使用フラグ
      confirmBtnFlg: true,
      // 運送データ作成フラグ
      transDataBtnFlg: true,
      // 運送済みデータの場合
      transOverKbn: false,
      // 新規区分
      localIsAdd: this.isAdd,
      // 待ちダイアログの表示フラグ
      showFlag: false,
      // 全て製品表示フラグ
      allProdShowFlg: false,

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 未入荷フラグ
      disRcvFlg: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //権限（false: 日本、true：大連（ 品質保証部））
      isDLUserLocal: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // 赤いデータの区分（0：なし、1：赤い表示）
      redRowKbn: 0,
      // 赤いデータ
      redRowList: [],

      // ========================初期リスト=================
      //連絡担当リスト
      connecterList: [],
      //運送状態リスト
      transStatusList: [],
      //輸送方式リスト
      transMethodList: [],
      //製品異常区分リスト
      prodExKbnList: [],
      // 仕入先リスト
      supNameList: [],
      // 運送区分リスト
      prodTransKbnList: [],
      //検索キー
      searchWord: "",
      // ====================チェックボックスの選択データ=============
      // 選択行のデータ
      selectedRows: [],
      // 変更列
      editableColumns: ["ptdTransQty", "ptdQc"],

      // ============================データ=====================
      // 重量合計
      weightTotal: 0,

      //基本データ
      prepTransEditForm: {
        ptbTransMethod: "", // 輸送方式
        ptbTransMethodShow: "", // 輸送方式
        ptbDepartureDateShow: "", // 出発日(読み取り用)
        ptbDepartureDate: "", // 出発日(保存用)
        ptbEstArrivalDateShow: "", // 到着予定日(読み取り用)
        ptbEstArrivalDate: "", // 到着予定日(保存用)
        ptbTransOrderNo: "", // 運送No（画面)
        ptbNo: "", // 発送予定No
        ptbDestination: "", // 目的地
        ptbTransStatus: "", // 状態
        ptbUserCode: "", // 連絡担当
        ptbRemarks: "", // 備考
        ptbUpdateTime: "", // 更新時刻
        ptbUpdateUser: "", // 更新者
      },

      // 発送予定一覧選択情報（画面表示）
      filteredDetailTable: [],

      //発送予定一覧選択情報
      prepTransDetailTable: [],

      //仕入先見積依頼のテーブルの列
      columns: [
        {
          label: t("resource.PREPARE_TRANS.BASIC_INFO"),
          children: [
            // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
            // {
            //   // 配送番号
            //   prop: "ptdTransDetailNo",
            //   label: t("resource.PREPARE_TRANS.TRANS_DETAIL_NO"),
            //   width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
            //   class: "cell_txt_left",
            //   overflowTooltip: false,
            // },
            // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
            {
              // 手配NO.
              prop: "ptdOrderNoShow",
              label: t("resource.PREPARE_TRANS.ORDER_NO"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_THIRTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              // 仕入先
              prop: "supName",
              label: t("resource.PREPARE_TRANS.SUPPLIER_COMPANY"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TEN"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
            // 緊急度の追加
            {
              prop: "aodUrgent",
              label: t("resource.ACCEPT_ORDER.AOD_URGENT"),
              width: t("widgetSize.tableCommon.width60"),
              align: "center",
            },
            // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
            {
              // 仕入先納期
              prop: "odDueDateShow",
              label: t("resource.PREPARE_TRANS.SUPPLIER_DUE_DATE"),
              width: t("widgetSize.COMMON_WIDTH.NINETY"),
              class: "cell_txt_center",
              overflowTooltip: false,
            },

            {
              // 得意先納期
              prop: "aodDeliveryDateShow",
              label: t("resource.PREPARE_TRANS.CUSTOMER_DELIVERY_DATE"),
              width: t("widgetSize.COMMON_WIDTH.NINETY"),
              class: "cell_txt_center",
              overflowTooltip: false,
            },
            // 品名
            {
              prop: "aodProdName",
              label: t("resource.PREPARE_TRANS.PRODUCT_NAME"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TEN"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            // 図番
            {
              prop: "aodProdDrawNo",
              label: t("resource.PREPARE_TRANS.PROD_DRAW_NO"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TEN"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            // 手配数
            {
              prop: "odProdQty",
              label: t("resource.PREPARE_TRANS.ORDER_QTY"),
              width: t("widgetSize.COMMON_WIDTH.SIXTY"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },
            // 重量
            {
              prop: "aodUWeight",
              label: t("resource.PREPARE_TRANS.PROD_WEIGHT"),
              width: t("widgetSize.COMMON_WIDTH.SIXTY"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },

            // 異常区分
            {
              prop: "ptdProdExKbnShow",
              label: t("resource.PREPARE_TRANS.ABNORMAL_DIFFERENCE"),
              width: t("widgetSize.COMMON_WIDTH.NINETY"),
              class: "cell_txt_center",
              overflowTooltip: false,
            },
          ],
        },

        //検査室入荷数
        {
          // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
          // label: t("resource.PREPARE_TRANS.CHECK_RECEIVE"),
          //入荷
          label: t("resource.PREPARE_TRANS.RECEIVE"),
          // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑
          children: [
            {
              // 入荷数
              prop: "chkRevQty",
              label: t("resource.PREPARE_TRANS.CHECK_RECEIVE_QUANTITY"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },
            // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
            // 検査室入荷日の追加
            {
              // 検査室入荷日
              prop: "chkRevDateShow", //chkRevDate
              label: t("resource.PREPARE_TRANS.RECEIVE_DATE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
              class: "cell_txt_center",
              overflowTooltip: false,
            },
            // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
            // ADD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
            // 日本入荷NG数の追加
            {
              // 日本入荷NG数
              prop: "jpRcvNgQty",
              label: t("resource.PREPARE_TRANS.JP_RCV_NG_SUM"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },
            // ADD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑
          ],
        },

        //運送
        {
          label: t("resource.PREPARE_TRANS.TRANSPORT_INFO"),
          children: [
            {
              // 運送済み数
              prop: "transOverQty",
              label: t("resource.PREPARE_TRANS.TRANSPORT_OVER_QTY"),
              width: t("widgetSize.COMMON_WIDTH.NINETY"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },
            {
              // 運送残
              prop: "transRemainQty",
              label: t("resource.PREPARE_TRANS.TRANS_REMAIN_QTY"),
              width: t("widgetSize.COMMON_WIDTH.SIXTY"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },
            {
              // 運送数
              prop: "ptdTransQty",
              label: t("resource.PREPARE_TRANS.TRANSPORT_QUANTITY"),
              width: t("widgetSize.COMMON_WIDTH.SIXTY"),
              class: "cell_txt_right",
              overflowTooltip: false,
            },
            {
              // QC
              prop: "ptdQc",
              label: t("resource.PREPARE_TRANS.PROD_QC"),
              width: t("widgetSize.COMMON_WIDTH.SIXTY"),
              class: "cell_txt_center",
              overflowTooltip: false,
            },
            // 運送予定
            {
              prop: "ptdCheckFlg",
              label: "運送予定",
              width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
              class: "cell_txt_center",
            },
            // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // 運送区分の削除
            // {
            //   // 運送区分
            //   prop: "ptdTransKbn",
            //   label: t("resource.PREPARE_TRANS.TRANS_KBN"),
            //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
            //   class: "cell_txt_center",
            //   overflowTooltip: false,
            // },
            // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            // 備考
            {
              label: t("resource.REMARKS_ADD.REMARKS"),
              class: "cell_txt_center",
              prop: "aodProdRemarksSum",
              min_width: 100,
              scopedSlots: {
                default: "aodProdRemarksSum",
              },
            },
            {
              // 更新時間
              prop: "ptdCheckUpdTimeShow",
              label: t("resource.PREPARE_TRANS.CHECK_UPD_TIME"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_THIRTY"),
              class: "cell_txt_center",
              overflowTooltip: false,
            },
          ],
        },
      ],

      //運送製品選択画面の検索条件
      selectedSearchConditionForm: [],

      //運送明細情報(保存用)
      prepTransDetailInfo: [],

      // ======================画面のheight================
      //基本情報のheight
      //49: collapseのheight 45: 輸送方式のheight 45：目的地 65：備考 45：ボタン
      basicHeight: 49 + 45 + 45 + 65 + 45,
      //明細情報のheight  (window.innerHeight * (1 - 0.1) - 65): 画面のheight
      detailHeight:
        window.innerHeight * 1 -
        65 -
        (49 + 45 + 45 + 65 + 45) -
        DIALOG_LINE_HEIGHT * 2 -
        35,

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 2,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      // ======================履歴用================
      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },

  watch: {
    filteredDetailTable: {
      handler(newVal) {
        this.prepTransDetailTable = this.prepTransDetailTable.map(
          (originalItem) => {
            const matchedItem = newVal.find(
              (item) =>
                item.ptdOrderNo === originalItem.ptdOrderNo &&
                item.ptdDetailNo === originalItem.ptdDetailNo
            );
            return matchedItem ? { ...matchedItem } : originalItem;
          }
        );
        this.weightTotalCountProc();
      },
      deep: true,
    },
  },

  mounted() {
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 権限の取得
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    this.init(this.rowData);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    //クリア処理
    handleClear() {
      this.$refs.searchInput = "";
      this.searchWord = "";
      this.handleCheckboxChange();
    },

    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;
      if (val.indexOf("prepTransBasic") !== -1) {
        this.basicHeight = 49 + 45 + 45 + 65 + 45;

        this.detailHeight =
          window.innerHeight * 1 -
          65 -
          (49 + 45 + 45 + 65 + 45) -
          DIALOG_LINE_HEIGHT * 2 -
          35;
      } else {
        this.basicHeight = 49 + 45;

        this.detailHeight =
          window.innerHeight * 1 - 65 - (49 + 45) - DIALOG_LINE_HEIGHT * 2 - 30;
      }

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      // 基本情報のリスト取得（仕入先、担当者）
      getInitList()
        .then((res) => {
          // 連絡担当リストの取得
          this.connecterList = res.userInfoList;
          // 運送状態
          this.transStatusList = res.ptbTransStatusList;
          // 製品異常区分リスト
          this.prodExKbnList = res.prodExKbnList;
          //　輸送方式リスト
          this.transMethodList = res.transMethodList;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 輸送方式（空白のオプション）の追加
          this.transMethodList.unshift({
            label: "",
            value: "",
          });
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

          // 仕入先リスト
          this.supNameList = res.supNameList;
          // 運送区分リスト
          this.prodTransKbnList = res.prodTransKbnList;
          // 初期値の設定
          this.setInitValue(data);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });

      // 列幅に自動調整
      // setColumnWidth(this.columns, this.prepTransDetailTable);
    },

    //初期値の設定
    setInitValue(data) {
      //新規作成の場合
      if (this.localIsAdd) {
        this.activeNames = ["prepTransBasic"];
        this.handleCollapseChange(this.activeNames);

        // 発送予定日:システム日
        this.prepTransEditForm.ptbDepartureDateShow = new Date();
        // 出発日:システム日
        this.prepTransEditForm.ptbDateShow = new Date();
        // 運送状態：新規
        this.prepTransEditForm.ptbTransStatus = this.transStatusList[0]?.value;
        this.prepTransEditForm.ptbTransStatusShow =
          this.transStatusList[0]?.label;
        // 輸送方式
        this.prepTransEditForm.ptbTransMethodShow = STR_EMPTY;
        // 連絡担当
        this.prepTransEditForm.ptbUserCode = getUserInfo().UserId;
        // 到着予定日
        this.prepTransEditForm.ptbEstArrivalDateShow = STR_EMPTY;
        // 運送No（画面)
        this.prepTransEditForm.ptbTransOrderNo = STR_EMPTY;
        // 目的地
        this.prepTransEditForm.ptbDestination = STR_EMPTY;
        // 備考
        this.prepTransEditForm.ptbRemarks = STR_EMPTY;
        this.getAbleList();
        this.btnOutputFlg = true;
        this.transDataBtnFlg = true;
        this.showFlag = false;

        //確定ボタンが使用可能に変更
        this.confirmBtnFlg = true;

        this.selectedSearchForm = [];
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);
        this.prepTransEditForm = data;

        //運送No.による運送詳細情報の取得
        this.getPrepTransDetailByNo();
        this.btnOutputFlg = false;
        this.transDataBtnFlg = false;

        // 輸送方式
        this.prepTransEditForm.ptbTransMethodShow = STR_EMPTY;

        //確定ボタンが使用可能に変更
        this.confirmBtnFlg = false;
      }
    },

    // 使用可能な担当者リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.prepTransEditForm.tbUserCode
      );
    },

    //運送NOによる運送詳細情報の取得
    getPrepTransDetailByNo() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      if (!this.prepTransEditForm.ptbNo || this.prepTransEditForm.ptbNo == "") {
        this.showFlag = false;
        Message.showError(t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE"));
        return;
      }

      searchPrepTransDetailByNo({
        ptdNo: this.prepTransEditForm.ptbNo,
      })
        .then((res) => {
          // 赤い区分
          this.redRowKbn = NUM_ZERO;
          // 赤いデータ
          this.redRowList = [];

          // 発送予定基本データ
          this.prepTransEditForm = res.prepTransBasicInfo;
          // 発送予定詳細データ
          this.prepTransDetailTable = res.prepTransDetailInfoList;

          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (
            res.prepTransDetailInfoList != null &&
            res.prepTransDetailInfoList.length != 0
          ) {
            this.aodUpdateTime = res.prepTransDetailInfoList[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          this.transOverKbn = this.prepTransEditForm?.ptbDelFlg === STR_ONE;
          // 全て製品表示フラグ(全て製品表示)
          this.allProdShowFlg = this.transOverKbn ? true : this.allProdShowFlg;

          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
          // 入荷機能の追加
          this.prepTransDetailTable.forEach((item, index) => {
            // 入荷ボタンフラグ： true:使用可能「入荷数量<手配数量」
            item.receiveFlag =
              item?.chkRevQty !== undefined &&
              item?.chkRevQty !== null &&
              !isNaN(item?.chkRevQty) &&
              item?.chkRevQty < item?.odProdQty &&
              !this.transOverKbn;

            //qc undefined ⇒ ""
            if (!item.hasOwnProperty("ptdQc")) {
              this.$set(this.prepTransDetailTable[index], "ptdQc", "");
            }
          });
          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

          // 重量合計の計算
          this.weightTotalCountProc();
          // 発送予定一覧選択情報（画面表示）
          this.handleCheckboxChange();
          // 読み込み回数 = 1
          if (!this.localIsAdd && this.numLoads == 1) {
            // 比較用基本情報
            this.cmpBasicResult = JSON.parse(
              JSON.stringify(this.prepTransEditForm)
            );
            // 比較用明細情報
            this.cmpDetailResult = this.extractDetail(
              JSON.parse(JSON.stringify(this.prepTransDetailTable))
            );
            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }

          this.getAbleList();
          // 列幅に自動調整
          // setColumnWidth(this.columns, this.prepTransDetailTable);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    dataProcess() {
      this.prepTransDetailTable.map((item) => {
        item.ptdProdExKbnShow = ShowMergeExKbn(
          item.ptdProdExKbn,
          item.ptdProdReceExKbn
        );
      });
    },
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

    //「一時保存」ボタン
    tempSave() {
      // フォーカス削除
      this.$refs.tmpSaveBtn.$el.blur();

      // 赤い区分
      this.redRowKbn = NUM_ZERO;
      // 赤いデータ
      this.redRowList = [];

      for (let index = 0; index < this.prepTransDetailTable.length; index++) {
        const element = this.prepTransDetailTable[index];
        //運送数>運送残（手配数 ― 運送済み数）
        if (
          // UPD 2026/03/06 Wjx 課題_260113顧客からの改善したい点への対応 start↓
          // データ保存効率の最適化(一時保存機能の運送数「0」のチェックの削除)
          // element.ptdTransQty > element.transRemainQty || element.ptdTransQty <= 0
          element.ptdTransQty > element.transRemainQty
          // UPD 2026/03/06 Wjx 課題_260113顧客からの改善したい点への対応 end↑
        ) {
          this.redRowKbn = NUM_ONE;
          this.redRowList.push(element);
        }
      }

      if (this.redRowKbn === NUM_ONE && this.redRowList.length > 0) {
        // 全て製品表示
        this.allProdShowFlg = true;
        this.handleCheckboxChange();

        let message = t("message.PREP_TRANS.TRANS_QTY_CHECK");
        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }

      //運送数>入荷数-運送済み数
      let rcvQtyCheckFlg = this.prepTransDetailTable.some(function (item) {
        return item.chkRevQty - item.transOverQty - item.ptdTransQty < 0;
      });

      if (rcvQtyCheckFlg) {
        // 問題があるデータの取得
        let rcvQtyChkData = this.prepTransDetailTable.filter((item) => {
          return item.chkRevQty - item.transOverQty - item.ptdTransQty < 0;
        });
        // 問題があるデータの運送数は赤いを表示
        if (rcvQtyChkData && rcvQtyChkData.length > 0) {
          // 全て製品表示
          this.allProdShowFlg = true;
          this.handleCheckboxChange();
          this.redRowKbn = NUM_ONE;
          this.redRowList = rcvQtyChkData;
        }
        let message = t("message.PREP_TRANS.CHECK_RCV_QTY_CHECK");

        Modal.showWarning("", message, {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
          cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
          showCancelButton: true,
        })
          .then(() => {
            this.saveDataProc();
          })
          .finally(() => {
            if (this.showFlag) {
              this.showFlag = false;
            }
          });
      } else {
        // 保存機能
        this.saveDataProc();
      }
    },

    // 発送予定保存
    saveDataProc() {
      if (this.prepTransDetailTable.length >= NUM_ONE) {
        if (this.localIsAdd) {
          //発送予定新規作成
          this.addPrepDetailProc();
        } else {
          //運送台帳編集保存
          this.updPrepTransDetailProc();
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // 運送単号作成
    transDetailNoCreate() {
      // 一覧表運送単号の最大値を取得
      let transNo = this.prepTransDetailTable.reduce(
        (max, row) => (row.ptdTransDetailNo > max ? row.ptdTransDetailNo : max),
        0
      );
      let transNoCounter = 1;
      // 運送単号が空の場合、「一覧表運送単号の最大値+1」を設定
      this.prepTransDetailTable.forEach((row) => {
        if (
          row.ptdTransDetailNo == null ||
          row.ptdTransDetailNo === STR_EMPTY
        ) {
          row.ptdTransDetailNo = transNo + transNoCounter;
          transNoCounter++;
          this.handleCheckboxChange();
        }
      });
      // フォーカス削除
      this.$refs.transDetailNoBtn.$el.blur();

      // 一時保存を実行
      // this.saveDataProc();
    },

    // 運送データ作成
    transInfoCreate() {
      // フォーカス削除
      this.$refs.transCreateBtn.$el.blur();

      // 全て製品表示
      this.allProdShowFlg = true;
      this.handleCheckboxChange();

      // 赤い区分
      this.redRowKbn = NUM_ZERO;
      // 赤いデータ
      this.redRowList = [];

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      let transNoFlg = NUM_ZERO;
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
      // 「運送データ作成」ボタンのチェックと機能の追加
      // let transSelectInfo = this.prepTransDetailTable.filter(
      //   (item) => item.ptdCheckFlgBool
      // );

      // if (!transSelectInfo || transSelectInfo.length <= 0) {
      //   Modal.showWarning(
      //     "",
      //     t("message.COMMON_MESSAGE.PLEASE_SELECT_TRANS_DATA"),
      //     {
      //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //     }
      //   );
      //   return;
      // }

      //「運送予定」を選んだデータ
      let prepTransDetailTableCheckedList = this.prepTransDetailTable.filter(
        (item) => item.ptdCheckFlgBool
      );

      //「運送予定」がチェックされているデータ = 0
      if (prepTransDetailTableCheckedList.length == 0) {
        Modal.showWarning("", t("message.PREP_TRANS.ALL_UNSELECTED_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 輸送方式非空のチェック
      if (this.isEmptyOrNull(this.prepTransEditForm.ptbTransMethod)) {
        Modal.showWarning("", t("message.PREP_TRANS.TRANS_METHOD_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      for (let index = 0; index < this.prepTransDetailTable.length; index++) {
        const element = this.prepTransDetailTable[index];

        //　運送単号が未作成の場合、エラーメッセージを表示する
        if (
          element.ptdCheckFlgBool &&
          (!element.ptdTransDetailNo ||
            element.ptdTransDetailNo == null ||
            element.ptdTransDetailNo == STR_EMPTY)
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
          // let message = t("message.PREP_TRANS.TRANS_NO_NULL_CHECK");
          // Modal.showWarning("", message, {
          //   confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          // });
          // return;
          transNoFlg = NUM_ONE;
          break;
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
        }

        //「運送数>運送残（手配数 ― 運送済み数）」の場合、エラーメッセージを表示する
        // 「入荷数 - 運送済み数 < 運送数」の場合、エラーメッセージを表示する
        if (
          element.ptdTransQty > element.transRemainQty ||
          element.ptdTransQty <= 0 ||
          (element.ptdCheckFlgBool &&
            element.ptdTransQty > element.chkRevQty - element.transOverQty)
        ) {
          this.redRowKbn = NUM_ONE;
          if (
            !this.redRowList.some(
              (item) =>
                item.ptdNo === element.ptdNo &&
                item.ptdPrepDetailNo === element.ptdPrepDetailNo
            )
          ) {
            this.redRowList.push(element);
          }
        }
      }

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      if (transNoFlg == NUM_ONE) {
        let message = t("message.PREP_TRANS.TRANS_NO_NULL_CHECK");
        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      // エラーメッセージを表示する
      if (this.redRowKbn === NUM_ONE && this.redRowList.length > 0) {
        let message = t("message.PREP_TRANS.TRANS_QTY_CHECK");
        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }

      // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
      // 「運送データ作成」ボタンのチェックと機能の追加
      //「運送予定」がチェックされていないデータ
      const hasUnselected = this.prepTransDetailTable.some(
        (item) => !item.ptdCheckFlgBool
      );
      // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

      // 選択したデータの運送数と手配数が一致しない場合、メッセージを表示する
      let orderNumFlg = this.prepTransDetailTable.some(function (item) {
        return item.ptdTransQty !== item.odProdQty && item.ptdCheckFlgBool;
      });

      if (orderNumFlg) {
        // 問題があるデータの運送数の取得
        let orderNumChkData = this.prepTransDetailTable.filter((item) => {
          return item.ptdTransQty !== item.odProdQty;
        });
        // 問題があるデータの運送数は赤いを表示
        if (orderNumChkData && orderNumChkData.length > 0) {
          this.redRowKbn = NUM_ONE;
          this.redRowList = orderNumChkData;
        }
        let message = t("message.PREP_TRANS.ORDER_TRANS_NUM_CHECK");

        Modal.showWarning("", message, {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
          cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
          showCancelButton: true,
        })
          .then(() => {
            // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
            // 「運送データ作成」ボタンのチェックと機能の追加

            //「運送予定」がチェックされていないデータ = 0
            if (hasUnselected) {
              let message = t(
                "message.PREP_TRANS.UNSELECTED_DATA_DELETE_CHECK"
              );

              Modal.showWarning("", message, {
                $type: "prompt",
                confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
                cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
                showCancelButton: true,
              }).then(() => {
                this.prepTransDetailTable = this.prepTransDetailTable.filter(
                  (item) => item.ptdCheckFlgBool
                );
                this.dataAddUpdProc();
                // 運送データ保存機能
                this.transInfoSaveProc();
              });
            } else {
              this.dataAddUpdProc();
              // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
              // 運送データ保存機能
              this.transInfoSaveProc();
            }
          })
          .finally(() => {
            // 待ちダイアログを閉じる
            if (this.showFlag) {
              this.showFlag = false;
            }
          });
      } else {
        // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
        // 「運送データ作成」ボタンのチェックと機能の追加

        //「運送予定」がチェックされていないデータ = 0
        if (hasUnselected) {
          let message = t("message.PREP_TRANS.UNSELECTED_DATA_DELETE_CHECK");

          Modal.showWarning("", message, {
            $type: "prompt",
            confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
            cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
            showCancelButton: true,
          }).then(() => {
            this.prepTransDetailTable = this.prepTransDetailTable.filter(
              (item) => item.ptdCheckFlgBool
            );
            this.dataAddUpdProc();
            // 運送データ保存機能
            this.transInfoSaveProc();
          });
        } else {
          this.dataAddUpdProc();
          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
          // 運送データ保存機能
          this.transInfoSaveProc();
        }
      }
    },

    // 運送データ保存機能
    transInfoSaveProc() {
      //保存前、データ処理
      transInfoCreate({
        ptdNo: this.prepTransEditForm.ptbNo,
        prepTransBasicInfo: this.prepTransEditForm,
        prepTransDetailInfoList: this.prepTransDetailInfo,
      })
        .then((res) => {
          this.numLoads = 1;
          //作成成功
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));

          //検索処理を行う
          this.getPrepTransDetailByNo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
          this.showFlag = false;
          // DEL 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 start↓
          // 出力のみ、データを保存しない(「出力失敗」場合、検索処理しない)
          //検索処理を行う
          //this.getPrepTransDetailByNo();

          // DEL 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 end↑
        });
    },

    //発送予定新規作成
    addPrepDetailProc() {
      //保存前、データ処理
      this.dataAddUpdProc();

      addPrepTransDetail({
        prepTransBasicInfo: this.prepTransEditForm,
        prepTransDetailInfoList: this.prepTransDetailInfo,
      })
        .then((res) => {
          this.prepTransEditForm.ptbNo = res;
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.localIsAdd = false;
          this.btnOutputFlg = false;
          this.transDataBtnFlg = false;
          //検索処理を行う
          this.getPrepTransDetailByNo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
          this.showFlag = false;
        });
    },

    // 運送詳細情報の更新
    updPrepTransDetailProc() {
      this.dataAddUpdProc();
      updPrepTransDetail({
        prepTransBasicInfo: this.prepTransEditForm,
        prepTransDetailInfoList: this.prepTransDetailInfo,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          //検索処理を行う
          this.getPrepTransDetailByNo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
          this.showFlag = false;
        });
    },

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      // 発送予定日
      this.prepTransEditForm.ptbDate = formatCurDateToString(
        this.prepTransEditForm.ptbDateShow
      );
      // 出発日
      this.prepTransEditForm.ptbDepartureDate = formatCurDateToString(
        this.prepTransEditForm.ptbDepartureDateShow
      );

      // 到着予定日
      this.prepTransEditForm.ptbEstArrivalDate = formatCurDateToString(
        this.prepTransEditForm.ptbEstArrivalDateShow
      );

      // 更新者
      this.prepTransEditForm.ptbUpdateUser = getUserInfo().UserId;

      this.prepTransDetailInfo = [];
      for (let index = 0; index < this.prepTransDetailTable.length; index++) {
        const element = this.prepTransDetailTable[index];

        this.prepTransDetailInfo.push({
          ptdNo: this.prepTransEditForm.ptbNo, // 発送予定基本_発送予定No
          ptdPrepDetailNo: index + 1, // 発送予定明細No
          ptdTransDetailNo: element.ptdTransDetailNo, // 運送単号
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // //発送製品選択区分 運送不可・運送数＝0の場合、デファクト：チェックしない
          // ptdCheckFlg:
          //   element.ptdTransKbn === STR_ZERO &&
          //   element.ptdTransQty > 0 &&
          //   element.ptdCheckFlgBool
          //     ? STR_ONE
          //     : STR_ZERO,

          //発送製品選択区分 運送不可・運送数＝0の場合、デファクト：チェックしない
          ptdCheckFlg:
            element.ptdQc !== "" && element.ptdCheckFlgBool
              ? STR_ONE
              : STR_ZERO,
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          ptdQc: element.ptdQc, // QC
          ptdTransQty: element.ptdTransQty, // 運送数量
          ptdProdExKbn: element.ptdProdExKbn, // 製品異常区分
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // ptdTransKbn: element.ptdTransKbn, //運送区分
          ptdTransKbn: element.ptdCheckFlgBool ? STR_ZERO : STR_ONE, //運送区分（0：運送不可、1：運送可）
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          ptdQuoteNo: element.ptdQuoteNo, //見積No
          ptdProdNo: element.ptdProdNo, //受注明細No
          ptdOrderNo: element.ptdOrderNo, //手配No
          ptdDetailNo: element.ptdDetailNo, //手配明細No
          ptdDetailNo: element.ptdDetailNo, //手配明細No
          ptdCheckUpdTime: element.ptdCheckUpdTimeShow, //発送製品選択check更新時間
          ptdUpdateUser: getUserInfo().UserId, //更新者
        });
      }
    },

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (!!row.ptdProdExKbn && row.ptdProdExKbn != STR_EMPTY) {
      //   if (row.ptdProdExKbn != STR_ZERO) {
      //     return "textColor";
      //   }
      // }
      if (row.ptdProdExKbnShow != NORMAL_PROD) {
        return "textColor";
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    // 未運送製品選択画面を表示
    ProdSelectDialog() {
      ShowPrepTransProdSelectDialog(
        {
          tableData: this.prepTransDetailTable,
          ptbNo: this.prepTransEditForm.ptbNo,
          selectedSearchForm: this.selectedSearchConditionForm,
        },
        t("resource.PREPARE_TRANS.NO_TRANSPORT_PROC_SELECT"),
        (target) => {
          if (!!target) {
            this.selectedSearchConditionForm = target.find(
              (item) => item.key === "searchConditionForm"
            )?.value;

            // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
            // 輸送方式（空白のオプション）の追加

            // if (this.selectedSearchConditionForm.searchTransMethod) {
            //   this.prepTransEditForm.ptbTransMethod =
            //     this.selectedSearchConditionForm.searchTransMethod;
            // } else {
            //   this.prepTransEditForm.ptbTransMethod = STR_ONE;
            // }
            // this.prepTransEditForm.ptbTransMethodShow =
            //   this.transMethodList.find(
            //     (item) =>
            //       item.value ===
            //       this.selectedSearchConditionForm.searchTransMethod
            //   )?.label;

            //輸送方式
            this.prepTransEditForm.ptbTransMethod = this.transMethodList.find(
              (item) =>
                item.label ===
                target.find((t) => t.key === "transMethodSelected")?.value
            )?.value;
            // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

            //発送予定一覧選択情報
            let selectData = target.find(
              (item) => item.key === "selectedProcForm"
            )?.value;

            getProdSelectData({
              prepTransDetailInfoList: selectData,
            })
              .then((res) => {
                const map = new Map(
                  this.prepTransDetailTable.map((item) => [
                    item.ptdOrderNo + item.ptdDetailNo,
                    item,
                  ])
                );

                res.prepTransDetailInfoList.forEach((item) => {
                  const key = item.ptdOrderNo + item.ptdDetailNo;
                  if (map.has(key)) {
                    const originalItem = map.get(key);
                    item.ptdTransDetailNo = originalItem.ptdTransDetailNo;
                    item.ptdCheckFlgBool = originalItem.ptdCheckFlgBool;
                    item.ptdTransQty = originalItem.ptdTransQty;
                    item.ptdQc = originalItem.ptdQc;
                    // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                    // item.ptdTransKbn = originalItem.ptdTransKbn;
                    // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                    item.ptdCheckUpdTimeShow = originalItem.ptdCheckUpdTimeShow;
                  }
                  // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
                  //運送数：初期値が「運送残」に変更
                  else {
                    // ADD 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 start↓
                    // 最大運送単号
                    var maxValue =
                      res.prepTransDetailInfoList?.reduce((max, item) => {
                        const num = Number(item.ptdTransDetailNo);
                        return !isNaN(num) && num > max ? num : max;
                      }, 0) || 0;

                    // 運送単号存在の場合
                    if (maxValue != 0) {
                      // 新しい運送単号＝最大運送単号+1
                      item.ptdTransDetailNo = maxValue + 1;
                    }
                    // ADD 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 end↑

                    item.ptdTransQty = item.transRemainQty;
                  }
                  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
                  // 入荷機能の追加
                  // 入荷ボタンフラグ： true:使用可能「入荷数量<手配数量」
                  item.receiveFlag =
                    item?.chkRevQty !== undefined &&
                    item?.chkRevQty !== null &&
                    !isNaN(item?.chkRevQty) &&
                    item?.chkRevQty < item?.odProdQty;
                  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

                  // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
                });

                this.prepTransDetailTable = res.prepTransDetailInfoList;

                // 発送予定一覧選択情報（画面表示）
                this.handleCheckboxChange();

                // 列幅に自動調整
                // setColumnWidth(this.columns, this.prepTransDetailTable);
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });

            //確定ボタンが使用可能に変更
            this.confirmBtnFlg = false;

            // setColumnWidth(this.columns, this.prepTransDetailTable);
          }
        }
      );

      // フォーカス削除
      this.$refs.selectBtn.$el.blur();
    },

    // 「発送予定単出力」ボタン
    OutPutClick() {
      if (typeof this.$refs.outPutBtn !== "undefined") {
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      }

      if (!this.showFlag) {
        this.showFlag = true;
      }

      // UPD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 start↓
      // 出力のみ、データを保存しない

      // if (!this.transOverKbn) {
      //   // 赤い区分
      //   this.redRowKbn = NUM_ZERO;
      //   // 赤いデータ
      //   this.redRowList = [];

      //   // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //   // let transSelectInfo = this.prepTransDetailTable.filter(
      //   //   (item) => item.ptdCheckFlgBool || item.ptdTransKbn === STR_ONE
      //   // );

      //   // if (!transSelectInfo || transSelectInfo.length <= 0) {
      //   if (
      //     !this.prepTransDetailTable ||
      //     this.prepTransDetailTable.length <= 0
      //   ) {
      //     // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      //     Modal.showWarning(
      //       "",
      //       t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"),
      //       {
      //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //       }
      //     );
      //     if (this.showFlag) {
      //       this.showFlag = false;
      //     }
      //     return;
      //   }

      //   for (let index = 0; index < this.prepTransDetailTable.length; index++) {
      //     const element = this.prepTransDetailTable[index];
      //     //運送数>運送残（手配数 ― 運送済み数）
      //     if (
      //       element.ptdTransQty > element.transRemainQty ||
      //       element.ptdTransQty <= 0
      //     ) {
      //       this.redRowKbn = NUM_ONE;
      //       this.redRowList.push(element);
      //     }
      //   }

      //   if (this.redRowKbn === NUM_ONE && this.redRowList.length > 0) {
      //     // 全て製品表示
      //     this.allProdShowFlg = true;
      //     this.handleCheckboxChange();

      //     let message = t("message.PREP_TRANS.TRANS_QTY_CHECK");
      //     Modal.showWarning("", message, {
      //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //     });
      //     if (this.showFlag) {
      //       this.showFlag = false;
      //     }
      //     return;
      //   }

      //   //運送数>入荷数-運送済み数
      //   let rcvQtyCheckFlg = this.prepTransDetailTable.some(function (item) {
      //     return item.chkRevQty - item.transOverQty - item.ptdTransQty < 0;
      //   });

      //   if (rcvQtyCheckFlg) {
      //     // 問題があるデータの運送数の取得
      //     let rcvChkData = this.prepTransDetailTable.filter((item) => {
      //       return item.chkRevQty - item.transOverQty - item.ptdTransQty < 0;
      //     });
      //     // 問題があるデータの運送数は赤いを表示
      //     if (rcvChkData && rcvChkData.length > 0) {
      //       this.redRowKbn = NUM_ONE;
      //       this.redRowList = rcvChkData;
      //       // 全て製品表示
      //       this.allProdShowFlg = true;
      //       this.handleCheckboxChange();
      //     }
      //     let message = t("message.PREP_TRANS.CHECK_RCV_QTY_CHECK");

      //     Modal.showWarning("", message, {
      //       $type: "prompt",
      //       confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //       cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //       showCancelButton: true,
      //     })
      //       .then(() => {
      //         // 「発送予定単出力」の出力
      //         this.outputProcess();
      //       })
      //       .finally(() => {
      //         if (this.showFlag) {
      //           this.showFlag = false;
      //         }
      //       });
      //   } else {
      //     // 「発送予定単出力」の出力
      //     this.outputProcess();
      //   }
      // } else {
      //   // 「発送予定単出力」の出力
      //   this.outputProcess();
      // }

      // 「発送予定単出力」の出力
      this.outputProcess();
      // UPD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 end↑
    },

    // 「発送予定単出力」の出力
    outputProcess() {
      // 待ちダイアログを表示する
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //保存前、データ処理
      this.dataAddUpdProc();

      // 「発送予定単出力」の出力
      outputExcelToZip(httpApi.OutPutPrepTransToExcel, {
        prepTransBasicInfo: this.prepTransEditForm,
        prepTransDetailInfoList: this.prepTransDetailInfo,
      })
        // UPD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 start↓
        // 出力のみ、データを保存しない(「出力失敗」場合、検索処理しない)
        //  .finally(() => {
        //       this.numLoads = 1;
        //       this.showFlag = false;
        //       //検索処理を行う
        //       this.getPrepTransDetailByNo();
        //     });
        .then(() => {
          //検索処理を行う
          this.getPrepTransDetailByNo();
        })
        .catch((err) => {
          this.showFlag = false;
          this.numLoads = 1;
        });
      // UPD 2026/03/06 Wjx 課題_260306顧客からの改善したい点への対応 end↑
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.localIsAdd) {
        isDataChanged = this.prepTransDetailTable.length > 0;
      } else {
        isDataChanged =
          !cmpBasicData(this.cmpBasicResult, this.prepTransEditForm) ||
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          //    !cmpDetailData(
          //   this.cmpDetailResult,
          //   this.extractDetail(this.prepTransDetailTable)
          // );
          !cmpDetailDataExceptRemarks(
            this.cmpDetailResult,
            this.extractDetail(this.prepTransDetailTable),
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // ["aodProdRemarksSum", "aodProdRemarks"]
            // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
            // 入荷機能の追加
            // ["aodProdRemarksSum", "aodProdRemarks", "aodUpdateTime", "index"]
            [
              "aodProdRemarksSum",
              "aodProdRemarks",
              "aodUpdateTime",
              "index",
              "chkRevQty",
              "receiveFlag",
            ]
            // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          );
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // 重量合計の計算処理を行う
    weightTotalCountProc() {
      this.selectedRows = [];
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 重量合計：全ての製品の重量合計
      // this.selectedRows = this.prepTransDetailTable.filter(
      // (row) => row.ptdCheckFlgBool
      // );
      this.selectedRows = this.prepTransDetailTable;
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      //重量合計 = 選択したデータの「重量　*　運送数」
      // this.weightTotal = this.selectedRows.reduce(
      //   (acc, item) => acc + item.aodUWeight * item.ptdTransQty,
      //   0.0
      // );
      this.weightTotal = parseFloat(
        this.selectedRows
          .reduce((acc, item) => {
            const weight = Number(item.aodUWeight);
            const quantity = Number(item.ptdTransQty);
            const accumulator = Number(acc);
            return accumulator + weight * quantity;
          }, 0.0)
          .toFixed(2)
      ); // 保留两位小数
    },

    // 削除選択データ
    deleteClickSelected() {
      if (typeof this.$refs.delBtn !== "undefined") {
        // フォーカス削除
        this.$refs.delBtn.$el.blur();
      }
      if (this.localIsAdd) {
        this.filteredDetailTable.forEach((row, index) => {
          row.ptdPrepDetailNo = index + 1;
        });
      } else {
        // 最大のptdPrepDetailNoが見つかりました
        let maxDetailNo = 0;
        this.filteredDetailTable.forEach((row) => {
          if (
            row.ptdPrepDetailNo !== null &&
            row.ptdPrepDetailNo > maxDetailNo
          ) {
            maxDetailNo = row.ptdPrepDetailNo;
          }
        });
        this.filteredDetailTable.forEach((row) => {
          if (row.ptdPrepDetailNo === null || row.ptdPrepDetailNo === 0) {
            maxDetailNo += 1;
            row.ptdPrepDetailNo = maxDetailNo;
          }
        });
      }

      // 選択データ
      let data = this.$refs.prepTransDetailTable.selection;

      // 選択したデータの発送予定明細No.のリスト
      let delList = data.map((item) => item.ptdPrepDetailNo);
      if (data.length >= 1) {
        Modal.showWarning("", t("resource.sys.deleteMessage"), {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        }).then(() => {
          // 待ちダウンロードを表示
          if (!this.showFlag) {
            this.showFlag = true;
          }
          // 更新/追加されたデータ処理
          this.dataAddUpdProc();

          delPrepTransByDetailNo({
            ptdNo: this.prepTransEditForm.ptbNo,
            delDetailNoList: delList,
            prepTransBasicInfo: this.prepTransEditForm,
            prepTransDetailInfoList: this.prepTransDetailInfo,
          })
            .then((res) => {
              //　削除区分（0：全部削除していない、1：全部削除）
              // 削除区分が「1：全部削除」の場合、新規の発送予定明細画面を表示する
              if (res.delKbn === STR_ONE) {
                this.localIsAdd = true;
                this.prepTransEditForm.ptbNo = STR_EMPTY;
                this.prepTransDetailTable = [];
                this.filteredDetailTable = [];
                let rowData = [];
                this.init(rowData);
              } else {
                this.numLoads = 1;

                // 新規データを保存後
                if (this.localIsAdd) {
                  this.prepTransEditForm.ptbNo = res.ptbNo;
                  this.localIsAdd = false;
                  this.btnOutputFlg = false;
                  this.transDataBtnFlg = false;
                }

                //検索処理を行う
                this.getPrepTransDetailByNo();
              }
              //削除成功
              Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));
            })
            .catch((err) => {
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
              }
              this.showFlag = false;
              //検索処理を行う
              this.getPrepTransDetailByNo();
            });
          // }
        });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // 全て製品表示の変化を監視する
    handleCheckboxChange() {
      // 発送予定一覧選択情報（画面表示）
      this.filteredDetailTable = this.allProdShowFlg
        ? this.prepTransDetailTable
        : this.prepTransDetailTable.filter((row) => !row.ptdCheckFlgBool);

      this.searchWord = this.searchWord.trim();
      if (
        this.searchWord !== STR_EMPTY &&
        this.searchWord !== undefined &&
        this.searchWord !== null
      ) {
        this.filteredDetailTable = this.filteredDetailTable.filter((data) => {
          return (
            (data.aodProdName && data.aodProdName.includes(this.searchWord)) || // 品名
            (data.ptdOrderNoShow &&
              data.ptdOrderNoShow.includes(this.searchWord)) || // 手配NO.
            (data.aodProdDrawNo &&
              data.aodProdDrawNo.includes(this.searchWord)) || // 図番
            // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
            // 検索キー：仕入先（曖昧検索）の追加
            (data.supName && data.supName.includes(this.searchWord)) // 仕入先
            // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑
          );
        });
      }

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 未入荷フラグ:trueの場合、入荷数が0のデータを表示する
      this.filteredDetailTable = this.disRcvFlg
        ? this.filteredDetailTable.filter((row) => row.chkRevQty === NUM_ZERO)
        : this.filteredDetailTable;
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      this.dataProcess();
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      let columnIndex = this.editableColumns.indexOf(columnProp);
      if (columnIndex == -1) {
        columnIndex = 0;
      }

      index = index + 1;

      if (index > this.filteredDetailTable.length - 1) {
        for (var i = 0; i < this.filteredDetailTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < this.filteredDetailTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.filteredDetailTable.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    //セルデータの保存
    changeCellData(row, column) {
      // 空のチェック
      row.ptdTransQty = this.checkNull(row.ptdTransQty);

      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // //　運送予定チェック、運送数が0・運送区分が運送不可の場合、運送予定がチェックしない
      // if (
      //   (row.ptdTransQty === NUM_ZERO || row.ptdTransKbn !== STR_ZERO) &&
      //   row.ptdCheckFlgBool
      // ) {
      //   this.filteredDetailTable[row.index].ptdCheckFlgBool = false;
      // }
      if (column == "ptdQc") {
        // QCが空の場合、運送予定がチェックしない；
        if (this.checkNullFlg(row.ptdQc) && row.ptdCheckFlgBool) {
          this.filteredDetailTable[row.index].ptdCheckFlgBool = false;
        } else if (!this.checkNullFlg(row.ptdQc) && !row.ptdCheckFlgBool) {
          // QCが空しない場合、運送予定がチェック
          this.filteredDetailTable[row.index].ptdCheckFlgBool = true;
        }
      }

      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      this.handleCheckboxClick(row);

      // 発送予定一覧選択情報を更新（画面表示）
      this.$set(this.filteredDetailTable, row.index, row);
    },

    // 発送製品選択checkboxの処理
    handleCheckboxClick(row) {
      // 運送予定チェックの場合、更新時間がシステム時間を表示する
      if (row.ptdCheckFlgBool) {
        // システム時間 ⇒　yyyy/MM/dd HH:mm
        row.ptdCheckUpdTimeShow = formatCurDateToYYYYMMddHHmm();
      } else {
        // その他の場合、空を表示する
        row.ptdCheckUpdTimeShow = STR_EMPTY;
      }
    },

    //　値が空のチェック
    checkNull(val) {
      if (!!!val || val === "" || typeof val === "undefined") {
        val = 0;
      }
      return val;
    },

    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    checkNullFlg(val) {
      if (!!!val || val === "" || typeof val === "undefined") {
        return true;
      }
      return false;
    },
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要
      if (!this.isDLUserLocal) {
        return;
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      //　変更可能列
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // var columnEditable = ["ptdTransKbn", "ptdCheckFlg", "ptdQc"];
      var columnEditable = ["ptdQc"];
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      if (columnEditable.includes(column.property) && !this.transOverKbn) {
        return "bg-cell-editable";
      }

      // 運送数の場合
      if (column.property === "ptdTransQty" && !this.transOverKbn) {
        return this.redRowKbn !== NUM_ZERO &&
          this.redRowList.some(
            (item) =>
              item.ptdNo === row.ptdNo &&
              item.ptdPrepDetailNo === row.ptdPrepDetailNo &&
              // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
              // 課題_納期分割機能の追加
              item.index == row.index
            // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          )
          ? "bg-cell-attention"
          : "bg-cell-editable";
      }
    },

    //テーブルで変更される可能性のある列の取得
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          index: index,
          ...item,
        };
      });
    },

    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      event.currentTarget.blur();

      if (!this.showFlag) {
        this.showFlag = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.ptdQuoteNo,
        row.ptdProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            // //　比較用明細情報の備考を変更する
            if (this.cmpDetailResult.length > 0) {
              this.cmpDetailResult.forEach((item) => {
                // 手配NO.と手配明細NO.一致の場合、備考を変更する
                if (
                  item.ptdOrderNo === row.ptdOrderNo &&
                  item.ptdDetailNo === row.ptdDetailNo
                ) {
                  item.aodProdRemarksSum = remarks;
                }
              });
            }
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.filteredDetailTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      showRemarksDialog(
        this,
        row.ptdQuoteNo,
        row.ptdProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // this.aodUpdateTime
        row.aodUpdateTime
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正
            // this.aodUpdateTime = res.aodUpdateTime;
            row.aodUpdateTime = res.aodUpdateTime;

            this.filteredDetailTable
              .filter((item) => item.ptdQuoteNo === row.ptdQuoteNo)
              .forEach((item) => {
                item.aodUpdateTime = row.aodUpdateTime;
              });
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
            this.$set(this.filteredDetailTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    // 運送済みのチェックボックスが選択不可の設定
    checkSelectable() {
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // return !this.transOverKbn;
      return !this.transOverKbn && this.isDLUserLocal;
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
    },
    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
    // 入荷機能の追加

    // 入荷ボタン
    addCheckReceDataProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();

      let isDataChanged =
        !cmpBasicData(this.cmpBasicResult, this.prepTransEditForm) ||
        !cmpDetailDataExceptRemarks(
          this.cmpDetailResult,
          this.extractDetail(this.prepTransDetailTable),

          [
            "aodProdRemarksSum",
            "aodProdRemarks",
            "aodUpdateTime",
            "index",
            "chkRevQty",
            "receiveFlag",
          ]
        );

      if (isDataChanged) {
        Modal.showWarning(
          "",
          t("message.PREP_TRANS.DATA_CHANGED_SAVE_FIRST").replace(
            "{0}",
            t("resource.PREPARE_TRANS.TEMP_SAVE_BUTTON")
          ),
          {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          }
        );
        return false;
      }

      //仕入先コード
      var supInfoArr = row.supName?.split(":");
      var cusCode = supInfoArr?.length > 0 ? supInfoArr[0] : "";

      var receBasicInfo = {
        crbReceNo: "",
        crbSupCode: cusCode, //仕入先Code
        crbSupInfo: row.supName, //仕入先Code: 仕入先名
        crbUserCode: localStorage.getItem(FINAL_STR.USER_ID), // 担当者Id //this.prepTransEditForm.ptbUserCode ,
        crbReceDate: formatDateToString(new Date()), // 入荷日
        crbStatus: FINAL_STR.RECE_STATUS_NEW, // 入荷状態
      };

      var receDetailInfo = [];
      receDetailInfo.push({
        crdReceNo: "",
        crdOrderNo: row.ptdOrderNo,
        crdDetailNo: row.ptdDetailNo,
        crdReceQty: row.odProdQty - row.chkRevQty,
        crdSizeCheckOkQty: row.odProdQty - row.chkRevQty,
        crdSizeCheckNgQty: 0,
        crdAppearanceCheck: 0,
        crdCloseQty: 0,
        crdQuoteNo: row.ptdQuoteNo,
        crdProdNo: row.ptdProdNo,
        crdProdExKbn: "0",
        crdReceDetailNo: 0,
        crdReceCompQty: row.chkRevQty,
      });

      const requestData = {
        BasicInfo: receBasicInfo,
        DetailInfo: receDetailInfo,
      };

      //入荷新規
      creatReceInfo(requestData)
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess("入荷" + t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          //検索処理を行う
          this.getPrepTransDetailByNo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError("入荷" + t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
/* ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ */
::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
/* ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ */
</style>
